import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown, Check } from "lucide-react";
import { SUPPORTED } from "@/i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const current = SUPPORTED.find((s) => s.code === i18n.language) || SUPPORTED[0];

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="lang-switcher-btn"
        aria-label={t("a11y.language")}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex items-center gap-1.5 text-ink/80 hover:text-ink ${
          compact ? "px-2 py-1 text-xs" : "px-3 py-1.5 text-sm"
        } border border-ink/15 hover:border-teal transition-colors`}
      >
        <Globe className="w-3.5 h-3.5" aria-hidden="true" />
        <span className="font-mono">{current.label}</span>
        <ChevronDown className="w-3 h-3" aria-hidden="true" />
      </button>
      {open && (
        <ul
          role="listbox"
          aria-label={t("a11y.language")}
          className="absolute right-0 top-full mt-1 w-40 bg-surface border border-ink/10 py-1 z-50"
        >
          {SUPPORTED.map((s) => (
            <li key={s.code} role="option" aria-selected={s.code === i18n.language}>
              <button
                data-testid={`lang-opt-${s.code}`}
                onClick={() => { i18n.changeLanguage(s.code); setOpen(false); }}
                className={`w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-ink/5 ${
                  s.code === i18n.language ? "text-teal" : "text-ink/80"
                }`}
              >
                {s.label}
                {s.code === i18n.language && <Check className="w-3.5 h-3.5" aria-hidden="true" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
